var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5444_2548",
    transform: "matrix(0.005 0 0 0.00703125 0 -0.00625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5444_2548",
    width: 200,
    height: 144,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACQCAYAAABNhSQEAAAAAXNSR0IArs4c6QAABKVJREFUeF7t2tFtIzsAQ9FRZ9nKktLSmR6mgH0jGBS8po5/LdPm5VwkGHtcHggg8FcCAxsEEPg7AYK4OhD4HwIEcXkgQBDXAAKvEfAX5DVuXnUIAYIcMrSarxEgyGvcvOoQAgQ5ZGg1XyOwJMic8+u1eK9C4N8lMMb4ffp0q4L8XNf1/RTmeQQ+icAY4/H6fzxwF55zEuSTlvdZlwgQZAmTQ6cSIMipy+u9RIAgS5gcOpUAQU5dXu8lAgRZwuTQqQSSgty3eO87WR4I1BAgSM2UiuwgkBTE9yA7FpL5VgJJQfyL9dYpvfkOAgTZQVVmDQGC1EypyA4CaUH8onfHSjLfRmCM8efpzZd+rPgU4nkEWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgkQpHVZvSIECBLBKKSVAEFal9UrQoAgEYxCWgksCTLn/GoFoNe5BMYYv0/tVwX5ua7r+ynM8wh8EoExxuP1/3jgLjznJMgnLe+zLhEgyBImh04lQJBTl9d7iQBBljA5dCoBgpy6vN5LBAiyhMmhUwkkBblv8d53sjwQqCFAkJopFdlBICmI70F2LCTzrQSSgvgX661TevMdBAiyg6rMGgIEqZlSkR0E0oL4Re+OlWS+jcAY48/Tmy/9WPEpxPMItBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBIgSOuyekUIECSCUUgrAYK0LqtXhABBIhiFtBJYEmTO+dUKQK9zCYwxfp/arwryc13X91OY5xH4JAJjjMfr//HAXXjOSZBPWt5nXSJAkCVMDp1KgCCnLq/3EgGCLGFy6FQCBDl1eb2XCBBkCZNDpxJICnLf4r3vZHkgUEOAIDVTKrKDQFIQ34PsWEjmWwkkBfEv1lun9OY7CBBkB1WZNQQIUjOlIjsIxATZ8eFkIvAJBJZ+rPgJRXxGBHYQIMgOqjJrCBCkZkpFdhAgyA6qMmsIEKRmSkV2ECDIDqoyawgQpGZKRXYQIMgOqjJrCPwHGiSwkQ1NkS0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.6ff455c236712cf74cb427c05a96ba6c.svg";
export { ForwardRef as ReactComponent };